import withUserGroupMembership from './withUserGroupMembership';

/**
 * determines if the current user is DCA employee or Digital stylist
 * @returns {function(*): function(*=, *): *}
 */
export const withChatUserGroup = () => {
  return withUserGroupMembership({
    isUserDCA: 'client_advisor',
    isUserDigitalStylist: 'stylist',
  });
};

export default withChatUserGroup;
